import { Component } from '@angular/core';
import { NewsService, InboxInput } from './../../services/news.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { ModalController } from 'ionic-angular';
import { UserModel } from './../../models/user.model';
import { Letter } from './../../models/letter.model';
import { OutboxSearch } from './outboxsearch';

@Component({
  selector: 'page-outbox',
  templateUrl: 'outbox.html',
  providers: [NewsService]
})
export class OutboxPage {

  constructor(
    private newsService: NewsService,
    private alert: AlertService,
    private loadding: LoaddingService,
    private storage: StorageService,
    private modalCtrl: ModalController) { }

  box = new InboxInput();
  isHave: boolean = false;
  username = this.storage.read<UserModel>("User").UserName;
  newss: Letter[];
  excludeTracks = [];
  hasmore = false;

  ionViewDidLoad() {
    this.box.userName = this.box.sendUserName = this.username;
    let load = this.loadding.showLoding();
    this.record(this.box).then(s => {
      this.loadding.closeLoading(load);
    });

  }

  //查询事件点击
  //chen 2017-01-12
  record(obj) {
    return this.newsService.getNews(obj, 1).then(s => {
      if (s.List != null) {
        if (obj.pageIndex == 1) {
          this.newss = [];
          this.newss = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.newss = this.newss.concat(s.List);
          if (this.newss.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            obj.pageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.newss = [];
      }
      if (this.newss.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }

    });
  }


  //查询条件
  //chen 2017-01-12
  presentFilter() {
    let modal = this.modalCtrl.create(OutboxSearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.box.startTime = this.excludeTracks["startDate"];
        this.box.endTime = this.excludeTracks["endDate"];
        this.box.receiveUserName = this.excludeTracks["people"] ? this.excludeTracks["people"] : "";
        this.box.pageIndex = this.excludeTracks["pageIndex"];
        this.record(this.box);
      }
    });
  }

  //下拉重新加载
  //TQQ 2016-12-29
  doRefresh(refresher) {
    this.box.pageIndex = 1;
    this.record(this.box).then(s => {
      refresher.complete();
    });
  }


  //上拉获取下一页信息
  doInfinite(infiniteScroll) {
    this.box.pageIndex++;
    this.record(this.box).then(s => {
      infiniteScroll.complete();
    });
  }

  //已读回调
  //TQQ 2017-02-24
  callback = () => {
    this.record(this.box);
  }


}





// WEBPACK FOOTER //
// ./src/pages/outbox/outbox.ts